import { keyframes } from '@emotion/css'
import styled from '@emotion/styled'

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`

export const Loading = styled('div')`
  width: ${props => props.size};
  height: ${props => props.size};
  border-radius: 50%;
  border: 3px solid #D5D5D4;
  border-top-color: rgba(194,194,194, 0.5);
  animation: 1.5s ${spin} infinite linear;
`
